module.exports = __webpack_public_path__ + "img/fichaclose.ce84b33c.png";